<template>
  <div>
    <v-dialog v-model="value" persistent max-width="500px" scrollable>
      <v-card>
        <v-card-title class="modal_title">
          <span class="modal_title-title">Ingresa el texto de la nota</span>
        </v-card-title>
        <v-card-text>
          <div class="d-flex justify-center align-center">
            <textarea
              v-model="text"
              cols="30"
              rows="10"
              @keyup="handleMaxChars"
              class="pa-2"
            ></textarea>
          </div>
          <div style="text-align: end">
            <span>{{ text.length }} de {{ sizeLimit }} caracteres</span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn primary flat @click="close" class="modal_button">
            {{ cancelText }}
          </v-btn>
          <v-btn
            color="primary"
            @click="submit"
            class="body-2 modal_button"
            :disabled="modals.showLoading || text.trim().length === 0"
          >
            {{ okText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Loading v-model="modals.showLoading" text="Cargando..." />
    <Error
      v-model="modals.showError"
      :text="isEdit ? 'Error al editar nota' : 'Error al crear nota'"
    />
    <Success
      v-model="modals.showSuccess"
      :text="isEdit ? 'Nota editada con éxito' : 'Nota creada con éxito'"
    />
  </div>
</template>

<script>
import Error from './Error.vue'
import Loading from './Loading.vue'
import Success from './Success.vue'

export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    value: Boolean,
    text: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
    },
    okText: {
      type: String,
      default: 'Guardar',
    },
    cancelText: {
      type: String,
      default: 'Cancelar',
    },
    editNoteEp: {
      type: String,
      default: 'checker/editNote',
    },
    addNoteEp: {
      type: String,
      default: 'checker/addNote',
    },
  },
  components: {
    Loading,
    Error,
    Success,
  },
  data: () => ({
    modals: {
      showLoading: false,
      showError: false,
      showSuccess: false,
    },
    sizeLimit: 200,
  }),
  methods: {
    handleMaxChars(e) {
      if (this.text.length > this.sizeLimit) {
        e.preventDefault()
        this.text = this.text.substring(0, this.sizeLimit)
      }
    },
    async submit() {
      if (this.text.trim() === '') return

      if (this.isEdit === false) {
        await this.createNote()
      } else {
        await this.editNote()
      }
    },
    async createNote() {
      this.modals.showLoading = true
      try {
        await this.$store.dispatch(this.addNoteEp, {
          idAttendance: this.id,
          data: { value: this.text },
        })

        this.modals.showSuccess = true
        this.$emit('changeNote', this.text)
        this.closeModal()
      } catch (error) {
        this.modals.showError = true
        console.log(error)
      } finally {
        this.modals.showLoading = false
      }
    },
    async editNote() {
      this.modals.showLoading = true
      try {
        await this.$store.dispatch(this.editNoteEp, {
          idAttendance: this.id,
          data: { value: this.text },
        })

        this.modals.showSuccess = true
        this.$emit('changeNote', this.text)
        this.closeModal()
      } catch (error) {
        this.modals.showError = true
        console.log(error)
      } finally {
        this.modals.showLoading = false
      }
    },
    close() {
      this.$emit('changeNote', undefined)
      this.closeModal()
    },
    closeModal() {
      this.$emit('input', !this.value)
    },
  },
  watch: {
    value() {
      if (this.value) {
        if (this.text === undefined) {
          this.text = ''
        }
      } else {
        this.text = ''
      }
    },
  },
}
</script>

<style scoped>
/* override css */
::v-deep .v-btn__content {
  text-transform: initial !important;
}

.modal_title {
  display: flex;
  flex-direction: column;
  font-weight: bold;
  padding-top: 20px;
  padding-bottom: 0px;
}

.modal_title-title {
  text-align: center;
  font-size: 20px;
  font-weight: 400;
}

.modal_button {
  margin: 0;
  width: 50%;
  border-radius: 8px;
  border: 1px solid #cccc;
  color: #272727;
  text-transform: capitalize;
}

.modal_button:last-of-type {
  width: calc(50% - 10px);
  margin-left: 10px;
  font-size: 14px;
  font-weight: 500;
}
textarea {
  resize: none;
  width: 80%;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
}
</style>
